export * from './actions';
export * from './effects';
export * from './service';

export {
  featureKey as postProjectKey,
  initialState as postProjectInitialState,
  State as PostProjectState,
} from './reducer';

export {
  getData as postProjectGetData,
  getError as postProjectGetError,
  getLoading as postProjectGetLoading,
  mapData as postProjectMapData,
} from './selectors';
